import { jsx as _jsx } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import React from "react";
const ListWrap = (props) => {
    const { id, dynamicList = [] } = props;
    return (_jsx(Stack, { direction: "row", useFlexGap: true, sx: {
            width: "100%",
            flexWrap: "wrap",
            gap: "16px",
        }, children: dynamicList.map((item, index) => (_jsx(Box, { sx: {
                p: "12px",
                backgroundColor: "background.grey",
                border: "1px solid",
                borderColor: "border.grey",
                color: "text.primary",
                fontSize: "14px",
                fontWeight: 500,
                lineHeight: "100%",
            }, children: item.label }, `${item.label}-${index}`))) }, id));
};
export default ListWrap;
